import type { AvatarUser } from '@core/account-ui';
import type { TellentMemberBrief } from '@core/ask-hr-types';
import { getInitials } from '@core/utils-legacy';

export const assigneeToAvatarUser = (assignee: TellentMemberBrief): AvatarUser => ({
  id: assignee.userGuid,
  firstName: assignee.firstName,
  lastName: assignee.lastName,
  initials:
    assignee.status === 'deactivated' ? '' : getInitials(assignee.firstName, assignee.lastName),
  hasAvatar: !!assignee.avatarThumbUrl,
  photoThumbUrl: assignee.avatarThumbUrl || '',
});
